module.exports = __webpack_public_path__ + "static/media/FLY.e957dc1c.png";